module.exports = __webpack_public_path__ + "static/media/default-resized.919676b4.jpg";